export default (value, expr) => {
  return parseInt(value) <= parseInt(expr)
}